document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-reels-slider]');

  sliders.forEach((slider) => {
    const viewport = slider.querySelector('[data-reels-viewport]');
    const track = slider.querySelector('[data-reels-track]');
    const prev = slider.querySelector('[data-reels-prev]');
    const next = slider.querySelector('[data-reels-next]');
    const cards = track ? Array.from(track.children) : [];

    if (!viewport || !track || cards.length === 0) return;

    let index = 0;

    const getVisibleCards = () => {
      if (window.innerWidth < 750) return 1;
      if (window.innerWidth < 991) return 2;
      return 3;
    };

    const getStep = () => {
      if (cards.length < 2) return viewport.offsetWidth;
      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(window.getComputedStyle(track).gap || 0);
      return cardWidth + gap;
    };

    const update = () => {
      const visible = getVisibleCards();
      const maxIndex = Math.max(0, cards.length - visible);
      if (index > maxIndex) index = maxIndex;

      const x = getStep() * index;
      track.style.transform = `translateX(-${x}px)`;

      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex;
    };

    if (prev) {
      prev.addEventListener('click', () => {
        index = Math.max(0, index - 1);
        update();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        const visible = getVisibleCards();
        const maxIndex = Math.max(0, cards.length - visible);
        index = Math.min(maxIndex, index + 1);
        update();
      });
    }

    window.addEventListener('resize', update);
    update();
  });
});